import { ReactNode } from 'react';

import { CloseButton, TextInput, TextInputProps, Textarea, TextareaProps } from '@mantine/core';
import { TimeInput } from '@mantine/dates';

import { useIcon } from '@/shared/hooks/useIcon';

import { FieldCaption } from '../FieldCaption';
import compactClasses from '../compactField.module.css';

import classes from './LabelInput.module.css';

type LabelInputProps = {
	type?: string;
	label?: string;
	icon?: ReactNode;
	iconSize?: number;
	multiple?: boolean;
	time?: boolean;
	/** Компактный вариант для десктопных фильтров и форм админки */
	compact?: boolean;
	/** Крестик очистки, пока в поле есть значение */
	clearable?: boolean;
	onClear?: () => void;
} & TextInputProps &
	TextareaProps;

export const LabelInput = ({
	label,
	type,
	iconSize,
	multiple = false,
	time = false,
	compact = false,
	clearable = false,
	onClear,
	...rest
}: LabelInputProps) => {
	const customIcon = useIcon({ type: type ?? '', size: iconSize });
	const fieldClasses = compact ? compactClasses : classes;
	const caption = <FieldCaption compact={compact}>{label}</FieldCaption>;
	const size = compact ? 'sm' : 'md';

	if (multiple)
		return (
			<Textarea
				classNames={{
					root: fieldClasses.root,
					label: fieldClasses.label,
					input: fieldClasses.textareaInput,
				}}
				label={caption}
				rightSection={customIcon}
				size={size}
				radius="lg"
				autosize
				{...rest}
			/>
		);

	if (time)
		return (
			<TimeInput classNames={fieldClasses} label={caption} size={size} radius="lg" {...rest} />
		);

	const clearButton = clearable && !!rest.value && (
		<CloseButton
			size="sm"
			aria-label="Очистить"
			// Фокус остаётся в поле, чтобы сразу ввести новое значение
			onMouseDown={(event) => event.preventDefault()}
			onClick={onClear}
		/>
	);

	return (
		<TextInput
			classNames={fieldClasses}
			label={caption}
			rightSection={clearButton || customIcon}
			rightSectionPointerEvents={clearButton ? 'all' : undefined}
			size={size}
			radius="lg"
			{...rest}
		/>
	);
};
